"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parsePhoneNumber = void 0;
const libphonenumber_js_1 = require("libphonenumber-js");
const formatCountryCallingCode = (countryCode, localPhoneNumber) => ({
    country_code: `+${countryCode}`,
    number: localPhoneNumber,
});
function parsePhoneNumber(inputPhoneNumber) {
    if (!inputPhoneNumber) {
        return;
    }
    // replace all non-digit chars except first plus and empty space
    const onlyDigitsNumber = inputPhoneNumber.replace(/(^[^+0-9])|((?!^)[^0-9 ])/g, "");
    // replace 00 with + before the phone number
    const phoneNumber = onlyDigitsNumber.startsWith("00") ? onlyDigitsNumber.replace(/^.{2}/g, "+") : onlyDigitsNumber;
    const parsedPhoneNumber = (0, libphonenumber_js_1.parsePhoneNumberFromString)(phoneNumber);
    if (parsedPhoneNumber && parsedPhoneNumber.country) {
        return formatCountryCallingCode(parsedPhoneNumber.countryCallingCode, parsedPhoneNumber.nationalNumber);
    }
    const textSearch = (0, libphonenumber_js_1.findPhoneNumbersInText)(phoneNumber);
    if (textSearch && textSearch.length > 0) {
        const firstFound = textSearch[0];
        if (firstFound && firstFound.number.country) {
            return formatCountryCallingCode(firstFound.number.countryCallingCode, firstFound.number.nationalNumber);
        }
    }
}
exports.parsePhoneNumber = parsePhoneNumber;
//# sourceMappingURL=parsePhoneNumber.js.map